import { createSelector } from 'reselect';

import { roles, accountStatuses } from 'src/constants/taxonomy';
import type { StoreState } from 'src/store/types';
import isAccountCrossSite from 'src/utils/getIsAccountCrossSite';

export const selectLocalEnvironment = (state: StoreState) =>
  state.environment === 'dev';

export const selectSite = (state: StoreState) => state.site;

export const selectAdCentreUserId = (state: StoreState) => state.adCentreUserId;

/**
 * @deprecated This function no longer use, will be removed in the future
 */
export const selectCurrentAdvertiserAccountId = (state: StoreState) =>
  state.selectedAdvertiserAccountId;

/**
 * @deprecated This function no longer use, will be removed in the future
 */
const selectAssumeAdministratorUntilLoaded = (state: StoreState) =>
  state.assumeAdministratorUntilLoaded;

/**
 * @deprecated This function no longer use, will be removed in the future
 */
const selectForceAdministrator = (state: StoreState) =>
  state.forceAdministrator;

const selectAccounts = (state: StoreState) => state.accounts || [];

/**
 * @deprecated This function no longer use, will be removed in the future
 */
export const selectActiveAccounts = createSelector(selectAccounts, (accounts) =>
  accounts.filter((account) => account.status !== accountStatuses.DEACTIVATED),
);

/**
 * @deprecated This function no longer use, will be removed in the future
 */
/**
 * @function selectCurrentAccountsForCurrentSite
 * An Account is allowed for the current site if it isn't a match for the peer site
 */
export const selectCurrentAccountsForCurrentSite = createSelector(
  selectActiveAccounts,
  selectSite,
  selectLocalEnvironment,
  (accounts, site, isLocalEnvironment) =>
    accounts.filter(
      (account) => !isAccountCrossSite({ account, site, isLocalEnvironment }),
    ),
);

/**
 * @deprecated This function no longer use, will be removed in the future
 */
export const selectCurrentAccount = createSelector(
  selectCurrentAdvertiserAccountId,
  selectCurrentAccountsForCurrentSite,
  (adCentreAdvertiserId, accounts) =>
    accounts.find(
      ({ advertiserId }) => advertiserId === adCentreAdvertiserId,
    ) ||
    accounts[0] ||
    {},
);

/**
 * @deprecated This function no longer use, will be removed in the future
 */
export const selectCurrentRole = createSelector(
  selectCurrentAccount,
  (account) => account.role,
);

/**
 * @deprecated This function no longer use, will be removed in the future
 */
export const selectIsAdministrator = createSelector(
  selectCurrentRole,
  selectAssumeAdministratorUntilLoaded,
  selectForceAdministrator,
  (role, assumeAdministrator, forceAdministrator) =>
    Boolean(
      role === roles.ADMINISTRATOR ||
        (!role && assumeAdministrator) ||
        forceAdministrator,
    ),
);

export const selectSeekAdvertiserId = (state: StoreState) =>
  state.seekAdvertiserId;

export const selectSeekBillingAccountId = (state: StoreState) =>
  state.seekBillingAccountId;

export const selectAdvertiserId = (state: StoreState) => state.advertiserId;
